<script context="module">
  import * as _ from "lodash";
  import * as LocaleString from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";

  // Month (abbreviated by default) Date, Year OR "--" if date nil
  export function convertToFormattedLocaleDate(date, monthFormat = "short") {
    return date
      ? new Date(date).toLocaleDateString("en-US", {
          month: monthFormat,
          day: "numeric",
          year: "numeric",
        })
      : "--";
  }

  // Month (abbreviated by default) Date, Year OR "--" if date nil.
  export function convertISODateStringToTimeZoneSafeFormattedLocaleDate(dateString) {
    // Handles timezone issues as seen here: https://stackoverflow.com/a/31732581/6933255
    const dateStringWithSlashesInsteadOfHyphens = _.replace(dateString, new RegExp("-", "g"), "/");
    const dateStringWithoutTimeAndTimezone = dateStringWithSlashesInsteadOfHyphens.split("T", 1)[0];

    return LocaleString.convertToFormattedLocaleDate(dateStringWithoutTimeAndTimezone);
  }

  // MM/DD/YYYY H:MM
  export function convertToLocalWithTime(date, useAt = false) {
    let newDate = new Date(date);
    let formattedDate = newDate.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    let formattedTime = newDate.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${formattedDate} ${useAt ? "at " : ""}${formattedTime}`;
  }

  export function convertToLocal(date, useAt = false) {
    let newDate = new Date(date);
    let formattedDate = newDate.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    return `${formattedDate} ${useAt ? "at " : ""}`;
  }

  // always shows central time no matter the users location
  export function convertToCentralTime(date) {
    let newDate = new Date(date);
    return newDate.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "America/Chicago",
    });
  }

  // Mon(string) Date, Year H:MM
  export function convertToDistributorLocalWithTime(date) {
    let newDate = new Date(date);
    let formattedDate = newDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    let formattedTime = newDate.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  }

  // Mon(string) Date, Year H:MM T
  export function convertToDistributorLocalWithTimeAndZone(date) {
    let newDate = new Date(date);
    let formattedDate = newDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    let formattedTime = newDate.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZoneName: "short",
    });

    return `${formattedDate} ${formattedTime}`;
  }

  // MM/DD/YYYY
  export function convertToDistributorDate(date) {
    return new Date(date).toLocaleDateString();
  }

  // Mon(string) Date, Year
  export function convertToDistributorDateLong(date) {
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  // Mon(string) Date, Year
  export function convertISODateToDistributorDateLong(dateStr) {
    const [year, month, day] = dateStr.split("-");

    // Subtract one from the month because Date takes months as zero based
    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  // Day, Mon(string) Date, Year
  export function convertISODateToDistributorDateLonger(dateStr) {
    const [year, month, day] = dateStr.split("-");

    // Subtract one from the month because Date takes months as zero based
    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      weekday: "short",
    });
  }
  // Day, Mon(string) Date, Year
  export function convertToDistributorDateLonger(date) {
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      weekday: "short",
    });
  }

  // YYYY-MM-DD
  export function trimmedISOFormat(d) {
    var date = d ? new Date(d) : new Date();
    return date.toISOString().split("T", 1)[0];
  }

  // Mon(string) Date, Year OR "--" if date nil, UTC timezone
  export function convertToFormattedLocaleUTCDate(date) {
    return date
      ? new Date(date).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          timeZone: "UTC",
        })
      : "--";
  }

  // Day of Week, M/D
  export function formatOrderFulfillmentDate(date) {
    return new Date(date).toLocaleDateString("en-US", {
      weekday: "long",
      month: "numeric",
      day: "numeric",
      timeZone: "UTC",
    });
  }

  // Day of Week, Mon Day UTC
  export function shortMonthFormatOrderFulfillmentDate(date) {
    return new Date(date).toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
      timeZone: "UTC",
    });
  }

  // Day of Week, Mon Day
  export const orderMessageThreadDate = date => {
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      weekday: "long",
    });
  };

  export const orderMessageDatetime = date => {
    return new Date(date).toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  export const convert24HourTimeTo12Hour = time => {
    const newDate = new Date("2001-01-01T" + time + "Z");
    return newDate
      .toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: true,
        hour: "numeric",
        minute: "numeric",
      })
      .toLowerCase();
  };
</script>
